@if (displayPromo && !hideStickyBanner) {
  <div [class.hidden]="timeMissing" class="bg-vis-banner text-vis-reverse sticky top-0 z-50">
    <div class="container sm:px-v-spacing">
      <div class="flex flex-col md:flex-row justify-between items-center">
        <div class="text-center">
          <span class="promo-text" [innerHTML]="promotionText"></span>
        </div>
        <div class="flex flex-wrap items-center justify-center text-center">
          <span>SALE ENDS IN</span>
          <div class="timer-container">
            @if (daysRemaining) {
              <div class="timer bg-ace-grey-800" [ngClass]="{ '--first': daysRemaining }">
                <span> {{ countdown | async | durationText : 'days' }}</span>
                <small>DAY</small>
              </div>
            }
            <div class="timer bg-ace-grey-800" [ngClass]="{ '--first': !daysRemaining }">
              <span> {{ countdown | async | durationText : 'hours' }}</span>
              <small>HRS</small>
            </div>
            <div class="timer bg-ace-grey-800">
              <span> {{ countdown | async | durationText : 'minutes' }}</span>
              <small>MIN</small>
            </div>
            @if (!daysRemaining) {
              <div class="timer bg-ace-grey-800">
                <span> {{ countdown | async | durationText : 'seconds' }}</span>
                <small>SEC</small>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
